import {
    type UscSaveActionsType,
    USC_SAVE_SET_CODE,
    USC_SAVE_SET_SAVING,
    USC_SAVE_SET_FAILED,
    USC_SAVE_INVALIDATE_CODE,
} from "../actions/UscSaveActions";
import type { UscLoadSaveCodeType } from "../../utils/tyCodeUtils";

export type UscSaveReducerType = {
    data: UscLoadSaveCodeType | null;
    saving: boolean;
    failed: boolean;
};

export const initialUscSaveReducerState: UscSaveReducerType = {
    data: null,
    saving: false,
    failed: false,
};

const UscSaveReducer = (
    state: UscSaveReducerType = initialUscSaveReducerState,
    action: UscSaveActionsType,
): UscSaveReducerType => {
    switch (action.type) {
        case USC_SAVE_SET_CODE: {
            const { data } = action;
            return { ...state, data, saving: false };
        }

        case USC_SAVE_SET_SAVING: {
            return { ...state, saving: true, failed: false };
        }

        case USC_SAVE_SET_FAILED: {
            return { ...state, failed: true, saving: false };
        }

        case USC_SAVE_INVALIDATE_CODE: {
            return { ...state, data: null, failed: false };
        }

        default:
            return state;
    }
};

export default UscSaveReducer;
